module.exports = require('lodash/isEmpty')
